<template>
  <div
    v-if="currBoard && currBoard.selectName"
    class="relative flex flex-row items-center justify-between min-h-[64px] px-[16px] xs:px-[24px] lg:px-[48px] xl:px-[204px] z-[20] bg-cover"
    :style="{
      'background-image': bgImageURL ? `url(${bgImageURL})` : 'none',
      'background-color': currBoard.themeColour,
    }"
  >
    <div class="inline-flex items-center">
      <BackButton
        compact
        disableSafeArea
        class="mr-[8px] shrink-0"
        :variant="isDarkThemeText ? 'on-dark' : 'default'"
        fallback-route="/tabs/home"
        aria-label="Go back"
      />
      <div class="flex flex-row items-center cursor-pointer" @click="redirectMainBoard">
        <span
          class="font-fofer text-white text-[1.375rem] xs:text-[1.75rem] leading-[1.25rem] font-medium"
          :style="{ color: currBoard.themeTextColour }"
        >
          Happy Birthday,
        </span>
        <div v-show="isPageUniqueToBoard" class="flex items-center ml-[8px] py-[6px]">
          <div class="mr-[4px]">{{ currBoard.selectName.emoji }}</div>
          <h1
            class="text-[1.25rem] leading-[1.5rem] font-light"
            :style="{ color: currBoard.themeTextColour }"
          >
            {{ currBoard.name }}
          </h1>
        </div>
      </div>
      <BoardSelect v-if="showBoardChange" class="ml-4" />
    </div>
    <img
      src="/assets/icons/board/hamburger.svg"
      class="h-[24px] w-[24px] cursor-pointer"
      :class="{
        'black-hamburger': currBoard.name === 'SPL' && currBoard.year === 2024,
        'brown-hamburger': currBoard.name === 'SPG' && currBoard.year === 2024,
      }"
      alt="menu logo"
      @click="openSideBar"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BoardSelect from '@/components/Board/Input/BoardSelect';
import BackButton from '@/components/common/BackButton.vue';

export default {
  components: {
    BoardSelect,
    BackButton,
  },
  props: {
    showBoardChange: {
      type: Boolean,
      default: false,
    },
    isPageUniqueToBoard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      windowWidth: 0,
    };
  },
  computed: {
    ...mapState('board', ['currBoard']),
    bgImageURL() {
      const background = this.currBoard?.navbarBackground;
      if (!background) return '';
      if (this.windowWidth < 768) return background.mobile;
      if (this.windowWidth < 1024) return background.tablet;
      return background.desktop;
    },
    isDarkThemeText() {
      // When theme text colour is light (e.g. white on dark board), flip the
      // back button to its on-dark variant so the arrow stays visible.
      const c = this.currBoard?.themeTextColour?.toLowerCase?.() || '';
      return c === '#fff' || c === '#ffffff' || c === 'white';
    },
  },
  created() {
    this.setWindowWidth();
    window.addEventListener('resize', this.setWindowWidth);
  },
  unmounted() {
    window.removeEventListener('resize', this.setWindowWidth);
  },
  methods: {
    openSideBar() {
      this.$store.dispatch('board/updateShowSideBar', true);
    },
    redirectMainBoard() {
      this.$store.dispatch('board/updateReadFilterValue', 'all');
      this.$store.dispatch('board/updateMyZoneFilterValue', 'all');
      this.$router.push('/birthdayboard');
    },
    setWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>
<style scoped>
.black-hamburger {
  filter: invert(1);
}

.brown-hamburger {
  filter: brightness(0) saturate(100%) invert(43%) sepia(10%) saturate(1000%) hue-rotate(351deg)
    brightness(96%) contrast(95%);
}
</style>
